import React, { useState, useEffect } from 'react';
import serverApi from '../../api/server';
// import { Typography } from 'antd';
import Typography from '@mui/material/Typography';

import './Merchant.css'
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import EditMerchantWalletModal from './EditMerchantWalletModal';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import LinearProgress from '@mui/material/LinearProgress';
import AddIcon from '@mui/icons-material/Add';
import AddWalletModal from './AddWalletModal';
import AddMerchantWalletModal from './AddMerchantWalletModal';
import { useMode } from 'src/hooks/ModeContext';
import copy from 'copy-to-clipboard';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DeleteWalletWarning from './DeleteWalletWarning';
import generateSignature from '../../api/apiAuth';
import MerchantWalletTransactionTable from './MerchantWalletTransactionTable';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';

import { CSVLink, CSVDownload } from "react-csv";

const { convertArrayToCSV } = require('convert-array-to-csv');
// const converter = require('convert-array-to-csv');
interface Asset {
    AssetPair: string;
    AssetWallet: string;
    Fee: string;
    Mode: string;
    Notes: string;
    WalletAddr: string;
    // LiqProvider: string;
}
// const { Text, Title } = Typography;
const Transition = React.forwardRef(function Transition(props:any, ref:any) {
    return <Slide direction="left" ref={ref} {...props} />;
});
function Row({asset,handleOpenEditWalletDialog, selected, updateWalletList, setUpdateWalletList, openDeleteWalletWarnning, handleOpenTransactionTableDialog, merchant} : any) {
    const [csvData, setCsvData] = useState([])
    const copyToClipboard = (walletAddress: string) => {
        copy(walletAddress)
    }
    const exportToCsv = (asset :Asset, event:any, done:any) => {
        console.log(asset)
        exportWalletTransactionData(merchant, asset.WalletAddr, event, done)
    }
    const exportWalletTransactionData = async(merchant: string, walletAddress:string, event:any, done:any) => {
        try {
            let resultJSONData;
            // if(state.mode === 'sdm') {
            //     console.log(state.mode)
            // }


            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const query = state.mode.toUpperCase()
            // const path = `/api/getExtTransactions?unit=${query}`

            // const signature = generateSignature("GET", timeStamp, path, query, null) 

            const result = await serverApi.get('/merchWalletTrans?name='+merchant+'&wallet='+walletAddress
            // , {headers: {Authorization: signature}}
            )
            console.log(result)
            resultJSONData = result.data
            console.log(resultJSONData)
            const csvFromArrayOfObjects = convertArrayToCSV(resultJSONData);
            setCsvData(csvFromArrayOfObjects)
            done()
        }
        catch (err) {
            alert(err)
            return []
        }
    }
    return (
        <>
            <TableRow selected={selected}>
                {/* <TableCell component="th" scope="row">
                        {asset.AssetPair}
                </TableCell> */}
                <TableCell>{asset.AssetWallet}</TableCell>
                <Tooltip title={asset.WalletAddr} placement="top"><TableCell>
                    <Button variant="text" onClick={(e) => {e.preventDefault(); copyToClipboard(asset.WalletAddr)}}>{asset.WalletAddr.substr(0, 7) + '...' + asset.WalletAddr.substr(asset.WalletAddr.length-7, asset.WalletAddr.length)}</Button>
                </TableCell></Tooltip>
                {/* <Tooltip title={asset.Description} placement="top"><TableCell><span style={{ whiteSpace: 'nowrap', overflow: 'hidden', width: '150px', display: 'block' }}>{asset.Description}</span></TableCell></Tooltip>
                <Tooltip title={asset.Notes && asset.Notes !== "\"\""? asset.Notes : ''} placement="top"><TableCell><span style={{ whiteSpace: 'nowrap', overflow: 'hidden', width: '150px', display: 'block' }}>{asset.Notes && asset.Notes !== "\"\""? asset.Notes : null}</span></TableCell></Tooltip> */}
                <TableCell>{asset.Mode}</TableCell>
                {/* <TableCell>{asset.Threshold? asset.Threshold: 0}</TableCell> */}
                <TableCell>{asset.Fee}</TableCell>
                {/* <TableCell>{asset.LiqProvider}</TableCell> */}
                {/* <TableCell>
                    <Button variant="text" onClick={() => handleOpenEditWalletDialog(asset)}>Edit</Button>
                </TableCell> */}
                {/* TODO: ADD USER ACCESS ROLE */}
                <Tooltip title={"You don't have permission to delete wallets"} placement="top">
                    <TableCell>
                        <IconButton disabled onClick={() => openDeleteWalletWarnning(asset)}>
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                </Tooltip>
                <TableCell>
                    <Button variant="text" onClick={() => handleOpenTransactionTableDialog(asset)}>Transactions</Button>
                </TableCell>
                {/* <TableCell>
                    <CSVLink
                        asyncOnClick={true}
                        onClick={(event, done) => exportToCsv(asset, event, done)}
                        style={{ color: "#000" }}
                        filename={merchant + '_' + asset.WalletAddr + '.csv'}
                        data={csvData}
                    ><FileDownloadIcon /></CSVLink>
                </TableCell> */}
            </TableRow>
        </>
    );
}
const provider:any = {
    'B2C2': 'B2C2',
    'DVCHAIN': 'DVChain'
}
function MerchantWallets({merchant, isAdmin}: any) {
    const [searchValue, setSearchValue] = useState('')
    const [clientWalletData, setClientWalletData] = useState<Asset[]>([]);
    const [searchResult, setSearchResult] = useState<Asset[]>([]);
    const [loading, setLoading] = useState(false);
    const [openAddWallet, setOpenAddWallet] = useState(false);
    const [currentSelectedWallet, setCurrentSelectedWallet] = useState<Asset>();
    const [openEditWallet, setOpenEditWallet] = useState(false);
    const [updateWalletList, setUpdateWalletList] = useState(0);
    const [openDeleteWarning ,setOpenDeleteWarning] = useState(false);
    const [currentSelectedVault, setCurrentSelectedVault] = useState({});
    const [openTransactionTable, setOpenTransactionTable] = useState(false);
    const [merchantTransactions, setMerchantTransactions] = useState([]);
    // const [currentSelectedWallet, setCurrentSelectedWallet] = useState({})
    const [state, action] = useMode();
    const [openAlert, setOpenAlert] = useState(false);
    // column filters
    const [assetFilterOn, setAssetFilterOn] = useState(false);
    const [filterAsset, setFilterAsset] = useState('');
    const [walletTypeFilterOn, setWalletTypeFilterOn] = useState(false);
    const [filterWalletType, setFilterWalletType] = useState('');
    const [modeFilterOn, setModeFilterOn] = useState(false);
    const [filterMode, setFilterMode] = useState('');
    const getWalletListByMerchant = async() => {
        try{
            let resultJSONData;
            const result = await serverApi.get('/getMerchantWallets?name='+merchant
                // {headers: {Authorization: signature}}
            )
            console.log(result)
            resultJSONData = result.data
            console.log(resultJSONData)
            setClientWalletData(resultJSONData)
        }
        catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        getWalletListByMerchant()
        getMerchantTransactions()
    },[updateWalletList])
    const handleSearchWalletValueOnChange = (e: any) => {
        let inputValue = (e.target.value).trim()
        setSearchValue(inputValue)
        let result = clientWalletData.filter((i: any) => (i.WalletAddr).toUpperCase().includes(inputValue.toUpperCase()))
        setSearchResult(result)
    }
    const handleClickClearSearchInput = () => {
        setSearchValue('')
    }
    const handleAddWalletModal = (state: boolean) => {
        setOpenAddWallet(state)
    }
    // const handleChangeLiquidityProvider = async(event: any, row: any) => {
    //     let updatedLP = event.target.value
    //     // console.log(row)
    //     let updateArr = [...clientWalletData];
    //     let curentRowIndex = updateArr.findIndex(i => i === row);
    //     const lpname : string = provider[updatedLP]
    //     // console.log(lpname)
    //     await updateLiquidityProvider(curentRowIndex.toString(), lpname)
    //     updateArr[curentRowIndex].LiqProvider = updatedLP
    //     setClientWalletData(updateArr)

    // }
    // const updateLiquidityProvider = async(rowIdx: string, provider: string) => {
    //     try {
    //         const jsonData = {
    //             clientIndex: rowIdx,
    //             provider: provider
    //         };

    //         const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
    //         const path = 'api/updateClient' 

    //         const signature = generateSignature("POST", timeStamp, path, null, jsonData) 

    //         const res = await serverApi.post(`/updateClient`, jsonData, {headers: {Authorization: signature}})
    //         // console.log(res)
    //     }
    //     catch (err) {
    //         alert(err)
    //     }
    // }
    const handleWalletDetailChange = async(acct: any, asset: any, updatedAsset: any) => {
        // TODO: POST UPDATED INFO TO API HERE 
        let updateArr = [...clientWalletData];
        let curentRowIndex = updateArr.findIndex(i => i === asset);
        let currentRow = updateArr[curentRowIndex];
        if(currentRow) {
            //const clientWalletId = acct.AccId+'_'+ currentRow.WalletAddr
            currentRow = updatedAsset;
            let res = await updateWalletDetail(currentRow, updatedAsset)
            console.log(res)
            setClientWalletData(updateArr)
            setOpenEditWallet(false)
            //setCurrentSelectedVault({})
            setCurrentSelectedWallet(undefined)
        }
    }
    const updateWalletDetail = async(row: any, updatedAsset: any) => {
        try {
            const jsonData = {
                pair: updatedAsset.AssetPair,
                asset: updatedAsset.AssetWallet,
                description: updatedAsset.Description,
                notes: updatedAsset.Notes,
                address: row.WalletAddr,
                mode: updatedAsset.Mode,
                fee: updatedAsset.Fee,
                liqprovider: updatedAsset.LiqProvider,
                threshold: updatedAsset.Threshold,
            };
            // create sig

            const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            const path = '/api/updateExternalWallet' 

            const signature = generateSignature("POST", timeStamp, path, null, jsonData) 

            const res = await serverApi.post(`/updateExternalWallet`, jsonData, {headers: {Authorization: signature}})

            console.log(res)
        }
        catch (err) {
            alert(err)
        }
    }
    const getMerchantTransactions = async() =>{
        try {
            let resultJSONData;
            const result = await serverApi.get('/merchTrans?name='+merchant
                // {headers: {Authorization: signature}}
            )
            console.log(result)
            resultJSONData = result.data
            console.log(resultJSONData)
            setMerchantTransactions(resultJSONData)
            return resultJSONData
        }
        catch (err) {
            alert(err)
            return []
        }
    }
    const handleOpenEditWalletDialog = (asset: any) => {
        setCurrentSelectedWallet(asset)
        setOpenEditWallet(true)
    }
    const openDeleteWalletWarnning = (asset: any) => {
        setCurrentSelectedWallet(asset)
        setOpenDeleteWarning(true)
    }
    const onCancelWalletDetailChange = (row: any, asset: any) => {
        setOpenEditWallet(false)
        //setCurrentSelectedVault({})
        setCurrentSelectedWallet(undefined)
    }
    const handleCloseAlert = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
    
        setOpenAlert(false);
    };
    const closeDeleteWalletWarnning = () => {
        setCurrentSelectedWallet(undefined)
        setOpenDeleteWarning(false)
    }
    const deleteWallet = async(assetpair: string, address:string) => {
        try{
            let counter = updateWalletList;
            //console.log(currentSelectedWallet)
            let jsonData = {
                name: merchant,
                WalletAddr: currentSelectedWallet?.WalletAddr,
            }
            // // generate sig

            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const path = '/api/deleteMerchWallet' 

            // const signature = generateSignature("POST", timeStamp, path, null, jsonData) 

            const res = await serverApi.post('/deleteMerchWallet', jsonData
            //, {headers: {Authorization: signature}}
            )
            //console.log(jsonData)
            if(res.status === 200){
                counter = updateWalletList + 1
                setUpdateWalletList(counter)
                handleOpenDeleteSuccessAlert()
                closeDeleteWalletWarnning()
            }
        } catch(err) {
            console.log(err)
        }
    }
    const handleOpenDeleteSuccessAlert = () => {
        setOpenAlert(true)
    }
    const handleOpenTransactionTableDialog = (asset: Asset) => {
        console.log(asset)
        setCurrentSelectedWallet(asset)
        setOpenTransactionTable(true)
    }
    const handleCloseTransactionTableDialog = () => {
        setOpenTransactionTable(false)
    }
    const handleFilterOn = (filter:string) => {
        if(filter === 'asset'){
            setAssetFilterOn(true)
        }
        else if(filter === 'walletType'){
            setWalletTypeFilterOn(true)
        }
        else if(filter === 'mode') {
            setModeFilterOn(true)
        }
    }
    const handleFilterOff = (filter:string) => {
        if(filter === 'asset'){
            setAssetFilterOn(false)
            setFilterAsset('')
        }
        else if(filter === 'walletType'){
            setWalletTypeFilterOn(false)
            setFilterWalletType('')
        }
        else if(filter === 'mode') {
            setModeFilterOn(false)
            setFilterMode('')
        }
    }
    const handleChangeFilter = (filter: string,event: SelectChangeEvent) => {
        if(filter === 'asset'){
            setFilterAsset(event.target.value)
        }
        else if(filter === 'walletType'){
            setFilterWalletType(event.target.value)
        }
        else if(filter === 'mode') {
            setFilterMode(event.target.value)
        }
    };
    
    return (
        <div className='clientsWalletContainer'>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 350, marginBottom: 1 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        value={searchValue}
                        onChange={(e) => handleSearchWalletValueOnChange(e)}
                        placeholder="Search Wallet Address"
                        inputProps={{ 'aria-label': 'search wallet address' }}
                        disabled={clientWalletData.length === 0}
                        endAdornment={searchValue? 
                            <InputAdornment position="end">
                                <IconButton
                                    size='small'
                                    onClick={handleClickClearSearchInput}
                                    style={{borderRadius: 0}}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </InputAdornment> : <SearchIcon />}
                    />
                    
                </Paper>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    {clientWalletData.length > 0 ? <Button sx={{height: '90%'}} disabled={!isAdmin} variant="outlined" size="small" endIcon={<AddIcon />} onClick={() => handleAddWalletModal(true)}>
                        Add Wallet
                    </Button> : null}
                    {merchantTransactions.length> 0 ?
                    <Button variant="contained" color='secondary' sx={{height: '90%', marginLeft: 5}} endIcon={<DownloadOutlinedIcon />}>
                        <CSVLink
                            asyncOnClick={true}
                            style={{ textDecoration: 'none', color: 'white' }}
                            filename={merchant +'_transaction.csv'}
                            data={merchantTransactions}
                        >
                            Transactions Report
                        </CSVLink>
                    </Button> : null}
                </div>
            </div>
            
            {clientWalletData.length > 0 ?
            <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
                {loading ? <LinearProgress color="success"/> : null}
                <Table stickyHeader aria-label="collapsible table" size='small'>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell>
                                <Typography variant="subtitle2" sx={{textAlign: 'center'}}>
                                    {assetFilterOn? 
                                        <Stack direction="row" spacing={0} justifyContent="center" alignItems="flex-end">
                                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                                <InputLabel id="demo-simple-select-standard-label">Asset Pair</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={filterAsset}
                                                    onChange={(e) => handleChangeFilter('asset', e)}
                                                    label="Asset Pair"
                                                >
                                                    {Array.from(new Set(clientWalletData.map((item) => item.AssetPair))).map(ui => (
                                                        <MenuItem key={ui} value={ui}>{ui}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <IconButton aria-label="filterOn" sx={{height: 40}} onClick={() => handleFilterOff('asset')}><FilterAltOffIcon /></IconButton>
                                        </Stack>
                                    :<>
                                        <strong>Asset Pair</strong>
                                        <IconButton aria-label="filterOn" onClick={() => handleFilterOn('asset')}><FilterAltIcon /></IconButton>
                                    </>}
                                </Typography>
                            </TableCell> */}
                            <TableCell>
                                <Typography variant="subtitle2" sx={{minWidth: 200}}>
                                    {walletTypeFilterOn ? 
                                        <Stack direction="row" spacing={0} justifyContent="center" alignItems="flex-end">
                                            <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                                                <InputLabel id="demo-simple-select-standard-label">Wallet Type</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={filterWalletType}
                                                    onChange={(e) => handleChangeFilter('walletType', e)}
                                                    label="Wallet Type"
                                                >
                                                    {Array.from(new Set(clientWalletData.map((item) => item.AssetWallet))).map(ui => (
                                                        <MenuItem key={ui} value={ui}>{ui}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <IconButton aria-label="filterOn" sx={{height: 40}} onClick={() => handleFilterOff('walletType')}><FilterAltOffIcon /></IconButton>
                                        </Stack>
                                    :<>
                                        <strong>Wallet Type</strong>
                                        <IconButton aria-label="filterOn" onClick={() => handleFilterOn('walletType')}><FilterAltIcon /></IconButton>
                                    </>}
                                </Typography>
                            </TableCell>
                            <TableCell><Typography variant="subtitle2"><strong>Address</strong></Typography></TableCell>
                            {/* <TableCell><Typography variant="subtitle2"><strong>Decription</strong></Typography></TableCell>
                            <TableCell><Typography variant="subtitle2"><strong>Notes</strong></Typography></TableCell> */}
                            <TableCell>
                                <Typography variant="subtitle2">
                                    {modeFilterOn? 
                                        <Stack direction="row" spacing={0} justifyContent="center" alignItems="flex-end">
                                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                                <InputLabel id="demo-simple-select-standard-label">Mode</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={filterMode}
                                                    onChange={(e) => handleChangeFilter('mode', e)}
                                                    label="Mode"
                                                >
                                                    {Array.from(new Set(clientWalletData.map((item) => item.Mode))).map(ui => (
                                                        <MenuItem key={ui} value={ui}>{ui}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <IconButton aria-label="filterOn" sx={{height: 40}} onClick={() => handleFilterOff('mode')}><FilterAltOffIcon /></IconButton>
                                        </Stack>
                                    :<>
                                        <strong>Mode</strong>
                                        <IconButton aria-label="filterOn" onClick={() => handleFilterOn('mode')}><FilterAltIcon /></IconButton>
                                    </>}
                                </Typography>
                            </TableCell>
                            {/* <TableCell><Typography variant="subtitle2"><strong>Threshold</Typography></TableCell> */}
                            <TableCell><Typography variant="subtitle2"><strong>Fee</strong></Typography></TableCell>
                            {/* <TableCell><Text strong>Liquidity Provider</Text></TableCell> */}
                            <TableCell />
                            <TableCell />
                            {/* <TableCell />
                            <TableCell /> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {searchValue? 
                            searchResult
                            .filter(client => filterAsset? client.AssetPair === filterAsset : client)
                            .filter(client => filterWalletType? client.AssetWallet === filterWalletType : client)
                            .filter(client => filterMode? client.Mode === filterMode : client)
                            .map((client, index) => (
                                // <ButtonBase key={client.WalletAddr + '-' + index} onClick={() => console.log('click click')}>
                                    <Row 
                                        key={client.WalletAddr + '-' + index} 
                                        asset={client} 
                                        selected={client == currentSelectedWallet}
                                        // handleChangeLiquidityProvider={handleChangeLiquidityProvider} 
                                        handleAddWalletModal={handleAddWalletModal}
                                        handleWalletDetailChange={handleWalletDetailChange}
                                        handleOpenEditWalletDialog={handleOpenEditWalletDialog}
                                        updateWalletList={updateWalletList}
                                        setUpdateWalletList={setUpdateWalletList}
                                        openDeleteWalletWarnning={openDeleteWalletWarnning}
                                        handleOpenTransactionTableDialog={handleOpenTransactionTableDialog}
                                        merchant={merchant}
                                        // handleOpenAlert={() => setOpenAlert(true)}
                                    />
                                // </ButtonBase>
                            ))
                            :clientWalletData
                            .filter(client => filterAsset? client.AssetPair === filterAsset : client)
                            .filter(client => filterWalletType? client.AssetWallet === filterWalletType : client)
                            .filter(client => filterMode? client.Mode === filterMode : client)
                            .map((client, index) => (
                                // <ButtonBase key={client.WalletAddr + '-' + index} onClick={() => console.log('click click')}>
                                    <Row 
                                        key={client.WalletAddr + '-' + index} 
                                        asset={client}
                                        selected={client == currentSelectedWallet}
                                        // handleChangeLiquidityProvider={handleChangeLiquidityProvider} 
                                        handleAddWalletModal={handleAddWalletModal}
                                        handleWalletDetailChange={handleWalletDetailChange}
                                        handleOpenEditWalletDialog={handleOpenEditWalletDialog}
                                        updateWalletList={updateWalletList}
                                        setUpdateWalletList={setUpdateWalletList}
                                        openDeleteWalletWarnning={openDeleteWalletWarnning}
                                        handleOpenTransactionTableDialog={handleOpenTransactionTableDialog}
                                        merchant={merchant}
                                        // handleOpenAlert={() => setOpenAlert(true)}
                                    />
                                // </ButtonBase>
                        )) }
                    </TableBody>
                </Table>
            </TableContainer> : 
            <div style={{display: 'flex', flexDirection: 'column', width: '20%'}}>
                <Typography variant="subtitle2"><strong>There's no external client wallet</strong></Typography>
                <Button variant="outlined" size="small" endIcon={<AddIcon />} disabled onClick={() => handleAddWalletModal(true)}>
                    Add Wallet
                </Button>

            </div>
            }
            <Dialog
                fullScreen
                open={openTransactionTable}
                onClose={handleOpenTransactionTableDialog}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }} color="primary">
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseTransactionTableDialog}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Transactions of {currentSelectedWallet?.WalletAddr}
                        </Typography>
                        {/* <Button autoFocus color="inherit" onClick={handleCloseMerchantDialog}>
                            save
                        </Button> */}
                    </Toolbar>
                </AppBar>
                <MerchantWalletTransactionTable walletAddress={currentSelectedWallet?.WalletAddr} merchant={merchant}/>
            </Dialog>
            <AddMerchantWalletModal 
                openDialog={openAddWallet} 
                closeDialog={() => setOpenAddWallet(false)} 
                row={currentSelectedVault} 
                updateWalletList={updateWalletList}
                setUpdateWalletList={setUpdateWalletList}
                mode={state.mode}
                merchant={merchant}
                // asset={currentSelectedWallet} 
                // onHandleWalletDetailChange={handleWalletDetailChange}
                // onCancelWalletDetailChange={() => setOpenAddWallet(false)}
            />
            <EditMerchantWalletModal 
                merchant={merchant}
                openDialog={openEditWallet} 
                closeDialog={() => setOpenEditWallet(false)} 
                row={currentSelectedVault} 
                asset={currentSelectedWallet} 
                onHandleWalletDetailChange={handleWalletDetailChange}
                onCancelWalletDetailChange={onCancelWalletDetailChange}
                updateWalletList={updateWalletList}
                setUpdateWalletList={setUpdateWalletList}
            />
            <Snackbar
                open={openAlert}
                autoHideDuration={6000}
                onClose={handleCloseAlert}
                message="Wallet deleted successfully"
                action={(
                    <>
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseAlert}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </>
                )}
            />
            <DeleteWalletWarning 
                open={openDeleteWarning}
                closeDialog={closeDeleteWalletWarnning}
                confirmDialog={deleteWallet}
            />

        </div>
    );
}

export default MerchantWallets;